import {Component, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {CartService} from '../../services/cart-service';
import {AppService} from '../../../../shared/services/app-service'; // TODO: Decouple

// Classes
import {Product} from '../../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SummaryCmp'));
 // TODO: update all debugOff( catalog:Summary )

@Component({
    selector: 'summary-cmp',
    template: require('./summary.cmp.html'),
    styles: [String(require('./summary.cmp.scss'))],
    host: {'class': 'summary clearfix'}
})
export class SummaryCmp {

    public _imgPaths = this._catalogService.imgPaths;
    private _summaryElement = true;
    private _subscriptions: any = {};

    
    constructor (
        private _catalogService: CatalogService,
        private _cartService: CartService,
        private _elementRef: ElementRef,
        private _appService: AppService, // TODO: Remove dependency, catalgo should not know about app
    ) {
        // 'Construct summary component' );
    }

    
    ngOnInit() {
        // 'Initialise summary component' );

        // Add identifier class
        this._cacheDomElements();
    }

    
    ngOnDestroy() {
        // 'Destroy summary component' );

        // Clear subscriptions
        for (let subscriptionId in this._subscriptions) {
            this._subscriptions[subscriptionId].unsubscribe();
        }
    }

    
    private _cacheDomElements () {
        debugOff( 'Cache dom elements' );

        this._summaryElement = this._elementRef.nativeElement;
        debugOff( 'Product element:', this._summaryElement );
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/summary/summary.cmp.ts